import { useMutation, useQueryClient } from '@tanstack/react-query';
import CatalogService from '@utility/services/catalog';
import { catalogMappingKeys } from '../lib/query-keys';
import type { ListingMappingBody } from '../lib/types';

export type ListingMappingVariables = {
  listingId: string;
  body: ListingMappingBody;
};

/*
 * Maps, re-maps or excludes one listing. Both tabs read the mappable-listings
 * queries (state unmapped, state mapped), so one prefix refreshes them.
 */
export function useListingMapping() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ listingId, body }: ListingMappingVariables) =>
      CatalogService.putListingMapping(listingId, body),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: catalogMappingKeys.mappableLists(),
      }),
  });
}
